/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const PhoneLandscapeIcon = /*#__PURE__*/ createSvgIcon(
  'PhoneLandscapeIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M16.43 11.03a1.03 1.03 0 100-2.06 1.03 1.03 0 000 2.06z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M2.26 4.5h15.48l.028.003a1.96 1.96 0 011.732 1.92v7.154a1.96 1.96 0 01-1.732 1.92l-.029.003H2.29V15l-.058.497A1.96 1.96 0 01.5 13.577V6.423a1.96 1.96 0 011.732-1.92L2.26 4.5zm.062 10h15.356a.96.96 0 00.822-.934V6.434a.96.96 0 00-.822-.934H2.322a.96.96 0 00-.822.934v7.132a.96.96 0 00.822.934z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.5 5v10h-1V5h1z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default PhoneLandscapeIcon;
